<div class="loader-container">
    <app-loader *ngIf="loading"></app-loader>
    <app-modal-header *ngIf="modalStyle" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{ 'modal-body': modalStyle }">
        <div class="row mb-3">
            <div class="col-12">
                <div class="text-center text-muted p-5" *ngIf="!item.organisation_id">
                    Koppel eerst een school aan de bestelling.
                </div>
                <table class="table" *ngIf="item.organisation_id">
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th>E-mail</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let manager of managerList">
                            <td>{{manager['name']}}</td>
                            <td>{{manager['email']}}</td>
                            <td>
                                <i class="bi bi-arrow-right-circle cursor-pointer p-3"
                                   (click)="select(manager['id'])"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
